<template>
  <div class="grid-container" style="min-height:70vh">
    <div class="grid-x grid-margin-x grid-padding-x mt-50">
        <div class="cell small-12 large-offset-3 large-6 mt-50 mb-50">
          <div class="text-center">
            <h1 class="big-title">Impressum</h1>
          </div>
          <div class="text mt-50 mb-50">
            ERGO Group AG<br>
            ERGO-Platz 1<br>
            40477 Düsseldorf<br>
<br>
            Tel 0800 3746 - 000 (gebührenfrei innerhalb Deutschland)<br>
            Tel +49 211 477 - 7100 (aus dem Ausland)<br>
            Fax 0211 477 - 1500<br>
<br>
            info@ergo.de<br>
<br>
            Vorsitzender des Aufsichtsrats Dr. Joachim Wenning<br>
<br>
            Vorstand Dr. Markus Rieß (Vorsitzender), Dr. Ulf Mainzer, Andree Moschner,<br>
            Dr. Clemens Muth, Heiko Stüber<br>
<br>
            Handelsregister Amtsgericht Düsseldorf, HRB 35978 USt-ID: DE192302697<br>
<br>
            Zuständige Aufsichtsbehörde Bundesanstalt für Finanzdienstleistungsaufsicht (BaFin) Graurheindorfer Str. 108 53117 Bonn Tel 0228 4108 - 0 Fax 0228 4108 - 1550 poststelle@bafin.de www.bafin.de

          </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'partnerPolicy',
  components: {
    
  },
  data() {
    return {
      state: this.$store.state,
      ui: {

      }
    }
  },
  async mounted() {
    this.$sleep(300)
    window.scrollTo(0,0)
    this.$store.trackingView("Impressum");
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="stylus" scoped>
.big-title {
  font-family: 'FedraSerifAPro'
  font-size 3.5em
  line-height: 1.2
  font-weight bold
  color #8E0038

  @media screen and (max-width: 39.9375em) {
    font-size 2.2em
  }
}

</style>